module.exports = __webpack_public_path__ + "img/mazda-dark-overlay-image-01.8860105a.jpeg";